import { useEffect, useState } from "react";
import { fetchPermissionsByRole } from "../../api/accessControl";

export default function RoleDetailsDrawer({ role, onClose }) {
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    if (role) {
      fetchPermissionsByRole(role.id).then(setPermissions);
    }
  }, [role]);

  if (!role) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-black/30 dark:bg-black/60">
      <div className="h-full w-[420px] bg-white p-6 text-gray-900 shadow-xl dark:bg-gray-900 dark:text-gray-100">
        <button
          onClick={onClose}
          className="mb-4 text-sm text-gray-700 transition hover:text-gray-900 dark:text-gray-300 dark:hover:text-white"
        >
          ← Close
        </button>

        <h2 className="mb-2 text-xl font-bold text-gray-900 dark:text-white">
          {role.name}
        </h2>

        <p className="mb-4 text-gray-600 dark:text-gray-400">
          {role.description}
        </p>

        <h3 className="mb-3 font-semibold text-gray-900 dark:text-white">
          Permissions
        </h3>

        {permissions.length === 0 ? (
          <p className="text-gray-500 dark:text-gray-400">No permissions</p>
        ) : (
          <ul className="space-y-2">
            {permissions.map((p) => (
              <li
                key={p.id}
                className="rounded bg-gray-100 px-3 py-2 text-gray-800 dark:bg-gray-800 dark:text-gray-200"
              >
                {p.code}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}